import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import {
  AppBarIcon,
  AppBarLink,
  AppBarLinkLabel,
  AppBarLinkWrapper
} from 'components/AppBar';

function AppBarFulfillmentTime({
  fulfillmentTimeOrASAPDisplay,
  onClick,
  shouldDisableFulfillmentOptions = false
}) {
  return (
    <AppBarLinkWrapper
      onClick={onClick}
      shouldDisableFulfillmentOptions={shouldDisableFulfillmentOptions}
    >
      <Box display={{ xs: 'none', md: 'flex' }} margin={'0 4px 0 0'}>
        <AppBarIcon icon="time" />
      </Box>
      <AppBarLink dataTestId="fulfillment-time">
        <AppBarLinkLabel>{fulfillmentTimeOrASAPDisplay}</AppBarLinkLabel>
      </AppBarLink>
    </AppBarLinkWrapper>
  );
}

AppBarFulfillmentTime.propTypes = {
  fulfillmentTimeOrASAPDisplay: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  shouldDisableFulfillmentOptions: PropTypes.bool
};

export default AppBarFulfillmentTime;
